// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*! Avalanche | MIT License | @colourgarden */.is-show{display:none}@media screen and (max-width:1024px){.is-show--portable{display:block}}@media screen and (min-width:1025px){.is-show--desk{display:block}}.heum-logo{display:block;width:32px;height:32px}.heum-logo__svg{fill:#fff;-webkit-transition:fill .3s;transition:fill .3s}.heum-logo--invert .heum-logo__svg{fill:#002147}", ""]);
// Exports
module.exports = exports;
